export default {

  methods: {
    dataParsing (data, path = '') {
      for (let k in data) {
        if (Array.isArray(data[k])) {
          for (let i = data[k].length - 1; i >= 0; i--) {
            this.dataParsing(data[k][i], path)
          }
        } else if (typeof data[k] === 'object') {
          this.dataParsing(data[k], path)
        }

        if (typeof data[k] !== 'function') {
          let newKey = k.charAt(0).toLowerCase() + k.slice(1)
          if (data[k] && ['audioUrl', 'imageUrl', 'descriptionAudioUrl', 'audio', 'video', 'slowAudio', 'path', 'mediaPath', 'explAudio', 'explVideo'].indexOf(newKey) > -1 && data[k].indexOf('http') === -1) {
            data[k] = path + '/' + data[k]
          }

          if (k !== newKey) {
            Object.defineProperty(data, newKey, Object.getOwnPropertyDescriptor(data, k))
            delete data[k]
          }
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/live-player/components/mixins/toolMixin.js